var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 41,
    rx: 20,
    fill: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2929 33.7071C19.6834 34.0976 20.3166 34.0976 20.7071 33.7071L27.0711 27.3431C27.4616 26.9526 27.4616 26.3195 27.0711 25.9289C26.6805 25.5384 26.0474 25.5384 25.6569 25.9289L20 31.5858L14.3431 25.9289C13.9526 25.5384 13.3195 25.5384 12.9289 25.9289C12.5384 26.3195 12.5384 26.9526 12.9289 27.3431L19.2929 33.7071ZM19 9L19 33H21L21 9H19Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNew);
export default __webpack_public_path__ + "static/media/arrowNew.85c578b3c4caefd609ffaef9dd52b22e.svg";
export { ForwardRef as ReactComponent };